const formStyle = {
        control: (base: any, state: any) => ({
            ...base,
            border: "1px solid var(--primary-color) !important",
            borderRadius: "5px",
            backgroundColor: state.isDisabled ? "#adadad" : "var(--input-color)",
            boxShadow: "none",
            minHeight: "45px",
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            pointerEvents: state.isDisabled ? "none" : "auto",
        }),
        placeholder: (base: any) => ({
            ...base,
            backgroundColor: "transparent",
            fontSize: "14px",
            color: "#000",
        }),
        menu: (base: any) => ({
            ...base,
            overflowY: "auto",
            scrollbarWidth: "none",
            color: "#000",
        }),
        menuList: (base: any) => ({
            ...base,
            maxHeight: "160px",
        }),
        menuPortal: (base: any) => ({
            ...base,
            zIndex: 2,
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isFocused ? "#eee" : "",
            color: "#000",
            fontWeight: state.isSelected ? "bold" : "",
        }),
        singleValue: (base: any, state: any) => ({
            ...base,
            color: state.selectProps.menuIsOpen ? "var(--input-color)" : state.isSelected ? "#000" : "#000",
        }),
        multiValueRemove: (base: any) => ({
            ...base,
            color: 'red',
        }),
    };

export default formStyle;